const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      if (typeof module.default === 'function') {
        const instance = module.default(node, ctx);
        const unsubscribe = ctx.on('unmount', () => {
          instance.unmount();
          unsubscribe();
        });
      }
    });
  };
};

// UI COMPONENTS ==============================================================
import MegaMenu from './components/ui/MegaMenu';

// NAV COMPONENTS ==============================================================
// import DesktopNav from './components/nav/DesktopNav';
// import MobileNav from './components/nav/MobileNav';

export const AppComponents = {
  // Content Components ------------------------------------------------------------
  MegaMenu,
  ProductComparison: asyncComponentFactory('content/ProductComparison'),
  ProductGallery: asyncComponentFactory('content/ProductGallery'),
  ProductCard: asyncComponentFactory('content/ProductCard'),
  ProductRecommendations: asyncComponentFactory('content/ProductRecommendations'),
  ProductFinder: asyncComponentFactory('content/ProductFinder'),
  VideoPlayer: asyncComponentFactory('content/VideoPlayer'),

  // MEDIA Components ------------------------------------------------------------
  // MediaPlayer: asyncComponentFactory('media/MediaPlayer'),

  // UI Components ------------------------------------------------------------
  Accordion: asyncComponentFactory('ui/Accordion'),
  // Hero: asyncComponentFactory('ui/Hero'),
  CartNotification: asyncComponentFactory('ui/CartNotification'),
  HeaderUtils: asyncComponentFactory('ui/HeaderUtils'),
  SiteHeader: asyncComponentFactory('ui/SiteHeader'),

  // NAV Components ------------------------------------------------------------
  FooterNav: asyncComponentFactory('nav/FooterNav'),
  // MobileNav,
};
